import { useMemo, useState } from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  Pagination,
  PaginationItem,
  Typography,
} from "@mui/material";
import useDashboardList from "../../hooks/useDashboardList";
import { formatPrice, discountedEventPrice } from "../../helpers/currency";
import moment from "moment";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import Background from "../../components/Background";
import { categoryList } from "../../constants/categories";
import { NextSlot, PreviousSlot } from "./IndustryHub";
import { formatEventType } from "../../constants/RegionalLocationList";

function showButton(evt) {
  return evt.eventType === "webinar" || evt.eventType === "virtual-event";
}

export default function Purchases({ searchTerm }) {
  const navigate = useNavigate();
  const isPremium = useSelector(
    (state) => state.profileSlice?.profile?.account?.isPremiumUser,
  );
  const token = localStorage.getItem("token");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [page, setPage] = useState(1);
  const request = useMemo(
    () => ({
      url: `/v1/web/event/myPurchase/all?page=${page}&limit=12`,
      method: "POST",
      body: { eventType: selectedCategory, eventTitle: searchTerm },
    }),
    [page, selectedCategory, searchTerm],
  );
  const { data, loading } = useDashboardList(request, token);
  const eventData = data.results;
  const totalRecords = data.total;

  const filterOutEventList = (type) => {
    setSelectedCategory(type);
    setPage(1);
  };

  const paginationSlots = {
    previous: PreviousSlot,
    next: NextSlot,
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handlePreviousClick = () => {
    if (page > 1) {
      setPage((page) => page - 1);
    }
  };

  const handleNextClick = () => {
    setPage((page) => page + 1);
  };

  return (
    <>
      <Background dashboardChrome={true}>
        {loading && <Loader />}
        <Box className="dashboard-main-div">
          <Box
            sx={{
              padding: {
                xs: "10px 0 20px",
                sm: "10px 0 20px",
                md: "10px 0 20px",
                lg: "10px 0 20px",
                xl: "20px 0 30px",
              },
            }}
          >
            <Container maxWidth="xl">
              <Grid container spacing={{ lg: 3, sm: 2, xs: 1 }}>
                <Grid
                  item
                  xs={12}
                  lg={10}
                  xl={9}
                  sx={{
                    margin: "auto",
                    overflow: "auto",
                  }}
                >
                  <Box
                    sx={{
                      width: {
                        xs: "535px",
                        sm: "auto",
                      },
                      overflowX: "auto",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: {
                        xs: "5px",
                        sm: "10px",
                        md: "10px",
                        lg: 3,
                      }, // Optional spacing between elements
                      scrollbarWidth: "none", // For Firefox
                      msOverflowStyle: "none", // For Internet Explorer and Edge
                      "&::-webkit-scrollbar": {
                        display: "none", // For Chrome, Safari, and other WebKit browsers
                      },
                    }}
                  >
                    {categoryList
                      ?.filter(
                        (i) =>
                          i.key != "videos-and-presentations" &&
                          i.key != "articles-and-blogs",
                      )
                      ?.map((category) => {
                        return (
                          <Box key={category.key}>
                            <Button
                              onClick={() => filterOutEventList(category.key)}
                              sx={{
                                backgroundColor:
                                  selectedCategory === category.key
                                    ? "#2A4876"
                                    : "#7BB9D5",

                                borderRadius: "100px",
                                padding: {
                                  xs: "10px 15px",
                                  sm: "10px 20px",
                                  md: "10px 20px",
                                  lg: "10px 30px",
                                },
                                color:
                                  selectedCategory === category.key
                                    ? "#ffffff"
                                    : "#152134",
                                fontSize: {
                                  xs: "12px",
                                  sm: "14px",
                                  md: "16px",
                                  lg: "17px",
                                  xl: "18px",
                                },
                                fontWeight: 400,
                                textTransform: "capitalize",
                                width: "auto",
                                minWidth: "initial",
                                marginBottom: {
                                  xs: "5px",
                                  sm: 0,
                                },
                              }}
                            >
                              {category?.value}
                            </Button>
                          </Box>
                        );
                      })}
                  </Box>
                </Grid>
              </Grid>
            </Container>
          </Box>
          <Box>
            <Container maxWidth="xl">
              <Grid container>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  lg={10}
                  xl={9}
                  sx={{ margin: "auto" }}
                >
                  {console.log("event data is", eventData)}
                  <Grid container spacing={{ lg: 5, sm: 2, xs: 2 }}>
                    {eventData?.length > 0 ? (
                      eventData?.map((evt) => {
                        const eventId = evt?.id ?? evt?._id;

                        return (
                          <Grid item xs={12} sm={6} md={6} lg={6} key={eventId}>
                            <Box
                              onClick={() =>
                                navigate(
                                  `/dashboard/details/${eventId}?my-events=true`,
                                  {
                                    state: evt,
                                  },
                                )
                              }
                              sx={{
                                width: "100%",
                                height: "100%",
                                overflow: "hidden",
                                borderRadius: "20px",
                                position: "relative",
                                cursor: "pointer",
                              }}
                            >
                              <Box
                                sx={{
                                  position: "absolute",
                                  top: "10px",
                                  right: "10px",
                                  width: "auto",
                                  padding: "0 10px",
                                  height: "38px",
                                  borderRadius: "50px",
                                  background: "#fff",
                                  fontSize: {
                                    xs: "10px",
                                    sm: "10px",
                                    md: "12px",
                                    lg: "12px",
                                    xl: "14px",
                                  },
                                  fontWeight: 400,
                                  color: "#2A4876",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {formatEventType("key", evt?.eventType)}
                              </Box>
                              <Box
                                sx={{
                                  background:
                                    "linear-gradient(180deg, rgba(0, 0, 0, 0) 5.83%, #000000 100%)",
                                  width: "100%",
                                  height: "100%",
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                }}
                              ></Box>
                              <Box
                                component="img"
                                src={evt?.eventPhoto}
                                alt="logo"
                                sx={{
                                  width: "100%",
                                  height: {
                                    xs: "200px",
                                    sm: "200px",
                                    md: "250px",
                                    lg: "300px",
                                    xl: "300px",
                                  },
                                  objectFit: "cover",
                                  borderRadius: "20px",
                                }}
                              />
                              <Box
                                sx={{
                                  width: "100%",
                                  position: "absolute",
                                  left: 0,
                                  bottom: 0,
                                  padding: {
                                    xs: "15px",
                                    sm: "15px",
                                    md: "15px",
                                    lg: "10px 10px 15px",
                                    xl: "20px",
                                  },
                                }}
                              >
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      color: "#ffffff",
                                      fontSize: {
                                        xs: "16px",
                                        sm: "16px",
                                        md: "16px",
                                        lg: "16px",
                                        xl: "20px",
                                      },
                                      lineHeight: {
                                        xs: "20px",
                                        sm: "20px",
                                        md: "20px",
                                        lg: "20px",
                                        xl: "30px",
                                      },
                                      textAlign: "left",
                                      fontWeight: 600,
                                    }}
                                  >
                                    {evt?.eventTitle}
                                  </Typography>
                                  {showButton(evt) && !isPremium && (
                                    <Box
                                      sx={{
                                        padding: "5px 10px",
                                        borderRadius: "10px",
                                        background: "#ffffff",
                                      }}
                                    >
                                      {evt?.discountInfo?.hasDiscount ? (
                                        <Box
                                          sx={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: { xs: "6px", sm: "8px" },
                                            flexWrap: "nowrap",
                                          }}
                                        >
                                          {/* Original price */}
                                          <Typography
                                            sx={{
                                              color: "#8A8A8A",
                                              fontSize: {
                                                xs: "11px",
                                                sm: "12px",
                                                md: "12px",
                                                xl: "16px",
                                              },
                                              fontWeight: 500,
                                              textDecoration: "line-through",
                                              lineHeight: 1,
                                            }}
                                          >
                                            ${formatPrice(evt?.eventFee)}
                                          </Typography>

                                          {/* Discounted price pill */}
                                          <Box
                                            sx={{
                                              backgroundColor: "#2A4876",
                                              color: "#fff",
                                              borderRadius: "8px",
                                              px: { xs: "6px", sm: "8px" },
                                              py: { xs: "2px", sm: "3px" },
                                              fontSize: {
                                                xs: "12px",
                                                sm: "13px",
                                                xl: "18px",
                                              },
                                              fontWeight: 700,
                                              lineHeight: 1.2,
                                            }}
                                          >
                                            $
                                            {formatPrice(
                                              discountedEventPrice(evt),
                                            )}
                                          </Box>
                                        </Box>
                                      ) : (
                                        <Typography
                                          sx={{
                                            color: "#2A4876",
                                            fontSize: {
                                              xs: "12px",
                                              sm: "12px",
                                              md: "12px",
                                              xl: "20px",
                                            },
                                            fontWeight: 600,
                                          }}
                                        >
                                          ${formatPrice(evt?.eventFee)}
                                        </Typography>
                                      )}
                                    </Box>
                                  )}
                                </Box>
                                {showButton(evt) && (
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                      paddingBottom: "10px",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Box
                                        component="img"
                                        src="/images/icons/time-circle-icon.png"
                                        alt="logo"
                                        sx={{
                                          width: {
                                            xs: "18px",
                                            sm: "18px",
                                            md: "18px",
                                            lg: "12px",
                                            xl: "18px",
                                          },
                                          height: {
                                            xs: "18px",
                                            sm: "18px",
                                            md: "18px",
                                            lg: "12px",
                                            xl: "18px",
                                          },
                                        }}
                                      />
                                      <Typography
                                        sx={{
                                          color: "#ffffff",
                                          fontSize: {
                                            xs: "12px",
                                            sm: "12px",
                                            md: "12px",
                                            lg: "12px",
                                            xl: "16px",
                                          },
                                          fontWeight: 400,
                                          paddingLeft: {
                                            xs: "10px",
                                            sm: "10px",
                                            md: "10px",
                                            lg: "5px",
                                            xl: "10px",
                                          },
                                          textAlign: "left",
                                        }}
                                      >
                                        {evt?.eventTimeStart}-
                                        {evt?.eventTimeEnd}
                                      </Typography>
                                    </Box>
                                    <Box
                                      sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        paddingLeft: {
                                          xs: "10px",
                                          sm: "10px",
                                          md: "10px",
                                          lg: "15px",
                                          xl: "20px",
                                        },
                                      }}
                                    >
                                      <Box
                                        component="img"
                                        src="/images/icons/calendar-icon-white.png"
                                        alt="logo"
                                        sx={{
                                          width: {
                                            xs: "18px",
                                            sm: "18px",
                                            md: "18px",
                                            lg: "12px",
                                            xl: "18px",
                                          },
                                          height: {
                                            xs: "18px",
                                            sm: "18px",
                                            md: "18px",
                                            lg: "12px",
                                            xl: "18px",
                                          },
                                        }}
                                      />
                                      <Typography
                                        sx={{
                                          color: "#ffffff",
                                          fontSize: {
                                            xs: "12px",
                                            sm: "12px",
                                            md: "12px",
                                            lg: "12px",
                                            xl: "16px",
                                          },
                                          fontWeight: 400,
                                          paddingLeft: {
                                            xs: "10px",
                                            sm: "10px",
                                            md: "10px",
                                            lg: "5px",
                                            xl: "10px",
                                          },
                                          textAlign: "left",
                                        }}
                                      >
                                        {moment
                                          .utc(evt?.eventDateStart)
                                          .format("MMM DD, YYYY")}
                                      </Typography>
                                    </Box>
                                  </Box>
                                )}
                                <Box
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {evt?.createdBy?.sponsorProfile?.logo && (
                                    <Box
                                      component="img"
                                      src={evt?.createdBy?.sponsorProfile?.logo}
                                      alt="logo"
                                      sx={{
                                        width: "26px",
                                        height: "26px",
                                        objectFit: "cover",
                                        borderRadius: "50px",
                                      }}
                                    />
                                  )}
                                  {evt?.createdBy?.sponsorProfile
                                    ?.companyName && (
                                    <Typography
                                      sx={{
                                        color: "#ffffff",
                                        fontSize: "14px",
                                        fontWeight: 600,
                                        paddingLeft: "10px",
                                      }}
                                    >
                                      {
                                        evt?.createdBy?.sponsorProfile
                                          ?.companyName
                                      }
                                    </Typography>
                                  )}
                                </Box>
                              </Box>
                            </Box>
                          </Grid>
                        );
                      })
                    ) : (
                      <Grid item xs={12}>
                        <Box
                          sx={{
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column",
                            textAlign: "center",
                            padding: { xs: "30px", sm: "40px", md: "60px" },
                          }}
                        >
                          <Box
                            sx={{
                              background: "#fff",
                              borderRadius: "20px",
                              padding: { xs: "25px 20px", sm: "40px 30px" },
                              maxWidth: "400px",
                              width: "100%",
                              boxShadow: "0px 4px 20px rgba(0,0,0,0.1)",
                            }}
                          >
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "20px",
                                  sm: "24px",
                                  md: "28px",
                                },
                                fontWeight: 700,
                                color: "#2A4876",
                                marginBottom: "15px",
                              }}
                            >
                              Let’s Find Your Next Event
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: { xs: "14px", sm: "16px" },
                                color: "#2A4876",
                                fontWeight: 400,
                                marginBottom: "25px",
                                lineHeight: 1.6,
                                textAlign: "left",
                              }}
                            >
                              You are not registered for any events yet. Let’s
                              change that! Visit the Echo Learn to browse events
                              and save your spot.
                            </Typography>

                            <Button
                              variant="contained"
                              onClick={() =>
                                navigate("/dashboard?active=learn")
                              }
                              sx={{
                                background: "#2A4876",
                                color: "#fff",
                                borderRadius: "25px",
                                padding: { xs: "8px 18px", sm: "10px 24px" },
                                fontSize: { xs: "14px", sm: "16px" },
                                fontWeight: 600,
                                textTransform: "none",
                                "&:hover": {
                                  background: "#1f3454",
                                },
                              }}
                            >
                              Visit Learn
                            </Button>
                          </Box>
                        </Box>
                      </Grid>
                    )}
                  </Grid>
                  {totalRecords > 12 && (
                    <Box
                      sx={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: {
                          xs: "15px 0",
                          sm: "30px",
                          md: "30px",
                          lg: "40px 40px 0",
                        },
                        "& ul li:last-child": {
                          position: {
                            xs: "unset",
                            md: "absolute",
                          },
                          right: "10%",
                        },
                        "& ul li:first-child": {
                          position: {
                            xs: "unset",
                            md: "absolute",
                          },
                          left: "10%",
                        },
                      }}
                    >
                      <Pagination
                        count={Math.ceil(totalRecords / 12)}
                        page={page}
                        onChange={handlePageChange}
                        renderItem={(item) => (
                          <PaginationItem
                            sx={{
                              fontSize: {
                                xs: "12px",
                                sm: "14px",
                                md: "16px",
                              },
                              minWidth: {
                                xs: "28px",
                                sm: "32px",
                              },
                              height: {
                                xs: "28px",
                                sm: "32px",
                              },
                              margin: {
                                xs: 0,
                                sm: "0 3px",
                              },
                            }}
                            {...item}
                            slots={paginationSlots}
                            slotProps={{
                              previous: { onClick: handlePreviousClick },
                              next: {
                                onClick: handleNextClick,
                                disabled: page === Math.ceil(totalRecords / 12),
                              },
                            }}
                          />
                        )}
                      />
                    </Box>
                  )}
                </Grid>
              </Grid>
            </Container>
          </Box>
        </Box>
      </Background>
    </>
  );
}
